import AppHeader from "../../layout/AppHeader";
import ServicesGroup from '../../xpost/views/register/services.group/ServicesGroup.vue';
import ServicesGroupAdd from '../../xpost/views/register/services.group/ServicesGroupAdd.vue';

const ServicesGroupRoutes = [
    {
        path: "/cadastro/gruposervico",
        name: "services.group",
        components: {
            header: AppHeader,
            default: ServicesGroup
        }
    },
    {
        path: "/cadastro/gruposervico/adicionar",
        name: "services.group.add",
        components: {
            header: AppHeader,
            default: ServicesGroupAdd
        }
    },
    {
        path: '/cadastro/gruposervico/adicionar/:id',
        name: 'services.group.edit',
        components: {
            header: AppHeader,
            default: ServicesGroupAdd
        }
    },
]

export default ServicesGroupRoutes;